/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FormQualitySection } from '../../models/form-quality-section';

export interface ListAllForForm$Params {
  formId: string;
}

export function listAllForForm(
  http: HttpClient,
  rootUrl: string,
  params: ListAllForForm$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<FormQualitySection>>> {
  const rb = new RequestBuilder(rootUrl, listAllForForm.PATH, 'get');
  if (params) {
    rb.path('formId', params.formId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FormQualitySection>>;
    })
  );
}

listAllForForm.PATH = '/forms/{formId}/quality-section';
